import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import { getUserData } from "../../../actions/user";
import { getSubscriptions } from "../../actions/userSettings";
import UserHeader from "../../../components/Library/UserHeader";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";

import ProfileSettings from "./ProfileSettings";
import SocialSettings from "./SocialSettings";
import SubscriptionSettings from "./SubscriptionSettings";

import styles from "./UserSettings.css";

class UserSettings extends Component {
  componentDidMount() {
    this.props.getUserData();
    this.props.getSubscriptions();
  }

  render() {
    return (
      <Layout className={styles.root} includeHeader={true} headerComponent={<UserHeader person={{ display_name: this.props.userSettings.data.profileInfo.display_name }} />}>
        <Sidebar className={styles.sidebar}>
          <Link to="/users/saved-stories" className={styles.sidebarLinks}>
            Saved Stories
          </Link>
          <Link to="/users/settings" className={classNames(styles.sidebarLinks, styles.active)}>
            Account
          </Link>
        </Sidebar>
        <Content>
          <ProfileSettings />

          <SocialSettings />

          <SubscriptionSettings />
        </Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userSettings: state.userSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserData: bindActionCreators(getUserData, dispatch),
    getSubscriptions: bindActionCreators(getSubscriptions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserSettings);



// WEBPACK FOOTER //
// ./src/users/components/UserSettings/UserSettings.js